import type { Extension } from '@tiptap/core';
import Collaboration from '@tiptap/extension-collaboration';
import CollaborationCursor from '@tiptap/extension-collaboration-cursor';
import StarterKit from '@tiptap/starter-kit';
import type { HocuspocusProvider } from '@hocuspocus/provider';
import type { Doc as YDoc } from 'yjs';
import type { PresenceUser } from './collab-presence';

export function buildEditorExtensions(input: {
  yDoc: YDoc;
  provider: HocuspocusProvider | null;
  currentUser: PresenceUser | null;
}): Extension[] {
  const extensions: Extension[] = [
    StarterKit.configure({ history: false }),
    Collaboration.configure({ document: input.yDoc, field: 'default' }),
  ];

  if (input.provider !== null && input.currentUser !== null) {
    extensions.push(
      CollaborationCursor.configure({
        provider: input.provider,
        user: {
          id: input.currentUser.id,
          name: input.currentUser.displayName,
          color: input.currentUser.color,
        },
      })
    );
  }

  return extensions;
}
